import { render, staticRenderFns } from "./label-value.vue?vue&type=template&id=74e839af&scoped=true&"
var script = {}
import style0 from "./label-value.vue?vue&type=style&index=0&id=74e839af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e839af",
  null
  
)

export default component.exports